import { observer } from 'mobx-react-lite'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import { HowAddNumberCards } from 'pages/settings/ui/HowAddInboxNumberCards/HowAddNumberCards'

export const HowAddNumber = observer(() => {
  const { commonStore, setAddNumberType, nextClickHandler } = useNewInboxStepsContext()
  const { unassignedNumbersCount, isGracePeriod, shouldHideAddNumbersFlow } = commonStore

  return (
    <HowAddNumberCards
      setAddNumberType={setAddNumberType}
      nextClickHandler={nextClickHandler}
      unassignedNumbersCount={unassignedNumbersCount}
      isGracePeriod={isGracePeriod}
      hiddenKeys={shouldHideAddNumbersFlow ? ['buy', 'app', 'landline'] : []}
    />
  )
})
